import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UtilService } from '../util/util.service';
import { finalize, tap } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(
    private util: UtilService,
    private loader: NgxUiLoaderService,
    private router: Router
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const started = Date.now();

    const headers:any = {
      session_id: this.util.getCookie('_session'),
    };

    const locale = this.util.getLocalStorageItem("locale")
    if(locale){
      headers["Accept-Language"] = locale
    }

    let ok: any;
    const token = this.util.getToken();
    

    if (token) {
      // make sure token is coming,
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          ...headers,
        },
      });
    } else if(request.url.includes('add-temp/user') || request.url.includes('add-temp/school')){
      console.log("running",)
    } else {
      request = request.clone({
        setHeaders: headers,
      });
    }

    this.loader.start();

    return next.handle(request).pipe(
      tap(
        // Succeeds when there is a response; ignore other events
        (event:any) => (ok = event instanceof HttpResponse ? 'succeeded' : ''),
        // Operation failed; error is an HttpErrorResponse
        (error: any) => (ok = error)
      ),
      // Log when response observable either completes or errors
      finalize(() => {
        this.loader.stop();
        const elapsed = Date.now() - started;
        if (ok == 'succeeded') {
          const msg = `${request.method} "${request.urlWithParams}"
          
           ${ok} in ${elapsed} ms.`;
          //  For make sure how much time consumed
          // console.log(msg);
        } else {
          if (ok['status'] == 401) {
            // logout from here
            this.router.navigate(['/']);
            console.log(ok['status']);
            localStorage.clear();

          }
          // else {
          //   if (request.url.search('users/bulkUploadProducts') == -1) {
          //     this.util.handleError(ok);
          //   }
          // }
        }
      })
    );
  }
}
